﻿<script setup lang="ts">
import { useModal } from '@/composables/useModal';
const { stack, closeModal } = useModal();
</script>

<template>
    <TransitionGroup
        name="modal"
        appear
    >
        <component
            v-for="(modal, index) in stack"
            :key="index"
            :is="modal.component"
            v-bind="modal.props"
            :style="{ zIndex: 1050 + index }"
            @close="closeModal()"
            @cancel="closeModal(false)"
            @confirm="closeModal(true)"
        />
    </TransitionGroup>
</template>

<style scoped>
.modal-enter-active,
.modal-leave-active {
    transition: opacity 0.3s ease-out;
}

.modal-enter-from,
.modal-leave-to {
    opacity: 0;
}
</style>
